import { isDisable } from "@lib/util/isDisable"
import { useFormikContext } from "formik"
import ButtonGroupBuyAdd from "./buttons-buy-add"

type Props = {
  businessName?: string
  isDisabledButton?: boolean
}

const ReviewCheckoutButtons = (props: Props) => {
  const form = useFormikContext()
  const { businessName, isDisabledButton } = props;
  const disable = isDisable(form)

  return (
    <div>
      <ButtonGroupBuyAdd disabled={disable} businessName={businessName} isDisabledButton={isDisabledButton}
      />
    </div>
  )
}

export default ReviewCheckoutButtons
